import styled from "styled-components";
import React from "react";

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const Styles = styled.div`
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  --dark060: hsl(218, 15%, 11%);
  --dark090: hsl(217, 16%, 12%);
  --dark100: hsl(217, 18%, 14%);
  --dark110: hsl(217, 18%, 16%);
  --dark200: hsl(222, 15%, 17%);
  --dark300: hsl(221, 15%, 21%);
  --dark400: hsl(222, 16%, 25%);
  --dark500: hsl(221, 15%, 29%);
  --dark500a: hsla(221, 15%, 29%, 0.5);
  --dark600: hsl(223, 15%, 33%);
  --dark700: hsl(222, 15%, 53%);
  --inputBorder: var(--dark300);
  --inputBackground: var(--dark300);
  --overlay: #afafaf4d;
  --gray050: hsl(0, 0%, 59%);
  --gray100: hsl(0, 0%, 69%);
  --gray200: hsl(210, 5%, 75%);
  --gray300: hsl(0, 0%, 88%);
  --gray400: hsl(0, 0%, 98%);
  --gray500: hsl(0, 0%, 100%);
  --blueBackground: hsl(230, 100%, 76%, 0.3);
  --blueBorderOverlay: hsl(230, 100%, 80%, 0.17);
  --blueBorder: hsl(230, 100%, 80%, 0.5);
  --blue030: hsl(230, 42%, 37%);
  --blue060: hsl(230, 27%, 49%);
  --blue090: hsl(230, 42%, 57%);
  --blue100: hsl(230, 42%, 62%);
  --blue200: hsl(230, 42%, 67%);
  --blue300: hsl(230, 42%, 72%);
  --blue400: hsl(229, 42%, 77%);
  --blue400a: hsla(229, 42%, 77%, 0.2);
  --blue500: hsl(229, 42%, 82%);
  --greenBackground: hsl(120, 57%, 46%, 0.3);
  --greenBorderOverlay: hsl(120, 100%, 66%, 0.17);
  --greenBorder: hsl(120, 100%, 66%, 0.5);
  --green100: hsl(120, 29%, 44%);
  --green200: hsl(120, 29%, 49%);
  --green300: hsl(120, 29%, 54%);
  --green300a: hsla(120, 29%, 54%, 0.2);
  --green400: hsl(120, 29%, 59%);
  --green500: hsl(120, 29%, 64%);
  --orangeBackground: hsl(36, 92%, 53%, 0.3);
  --orangeBorderOverlay: hsl(36, 100%, 76%, 0.17);
  --orangeBorder: hsl(36, 100%, 76%, 0.5);
  --orange100: hsl(36, 100%, 43%);
  --orange200: hsl(36, 100%, 48%);
  --orange300: hsl(36, 100%, 53%);
  --orange400: hsl(36, 100%, 58%);
  --orange400a: hsla(36, 100%, 58%, 0.2);
  --orange500: hsl(36, 100%, 63%);
  --redBackground: hsl(356, 100%, 62%, 0.3);
  --redBorderOverlay: hsl(356, 100%, 76%, 0.17);
  --redBorder: hsl(356, 100%, 76%, 0.5);
  --red060: hsl(356, 72%, 37%);
  --red100: hsl(356, 90%, 43%);
  --red200: hsl(356, 90%, 48%);
  --red300: hsl(356, 90%, 58%);
  --red400: hsl(356, 90%, 68%);
  --red400a: hsla(356, 90%, 68%, 0.2);
  --red500: hsl(356, 90%, 73%);
  --customAction: #ff65d6;
  --webhook: #65d8ff;
  --variable: #07dab0;
  --schedule: #e9bf17;
  --metadataView: #ba7fee;
  --listInput: #ffa065;

  color: var(--gray400);
`;

const ColorProvider = (props: Props) => {
  const { className, children } = props;
  return <Styles className={className}>{children}</Styles>;
};

export default ColorProvider;
